import * as Yup from 'yup';

const VulnerabilitySchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  owner_assignee: Yup.string().required('Owner is required'),
});

export { VulnerabilitySchema };
